import React from 'react';


export class ActionButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.generateState()
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props !== prevProps) {
            this.setState(this.generateState());
        }
    }

    generateState = () => {
        return {
            main: false,
            secondary: false,
            color: false,
            text: 'Button',
            icon: null,
            size: null,
            float: 'none',
            onClick: () => {},
            display: true,
            ...this.props
        };
    }

    getSize = () => {
        if (this.state.size === null) {
            return '';
        }

        return ' imd-button-' + this.state.size;
    }

    getClass = () => {
        if (this.state.main) {
            return 'imd-button imd-border-color-main imd-bg-gradient-reverse-main imd-text-180-main' + this.getSize();
        }

        if (this.state.color) {
            if (this.state.secondary) {
                return 'imd-button imd-button-secondary imd-border-color-' + this.state.color + ' imd-text-' + this.state.color + this.getSize();
            }

            return 'imd-button imd-border-color-' + this.state.color + ' imd-bg-gradient-reverse-' + this.state.color + ' imd-text-180-' + this.state.color + this.getSize();
        }

        if (this.state.secondary) {
            return 'imd-button imd-button-secondary imd-border-color-accent imd-text-accent' + this.getSize();
        }

        return 'imd-button imd-border-color-accent imd-bg-gradient-reverse-accent imd-text-180-accent' + this.getSize();
    }

    render() {
        return (
            <button
                className={this.getClass()}
                onClick={() => this.state.onClick()}
                style={{fontSize: '14.3pt', padding: '7px 1.6rem 5px 13px', display: 'inline-flex', alignItems: 'center'}}
            >
                <span
                    className={this.state.icon}
                    style={{display: 'inline-block', fontSize: '1.3em', margin: '0 0.8rem', paddingTop: '3px'}}
                />
                <span style={{display: 'inline-block'}}>
                        {this.state.text}
                </span>
            </button>
        );
    }
}
